<template>
    <div>
        <button type="button" class="button white uc home-search home-search-gtm" @click="showSubscribeModal">
            Subscribe
        </button>
    </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import debounce from "lodash/debounce";
import merge from "lodash/merge";

export default {
    data() {
        return {
            subscriber: {
                first_name: "",
                last_name: "",
                email: "",
                interested_in: "",
                pageUri: "",
                pageName: "",
            },

            loading: false,
        };
    },

    created: function () {
        this.subscriber.pageUri = window.location.href;
        this.subscriber.pageName = document.title;
    },
    methods: {
        showSubscribeModal() {
            this.$store
                .dispatch("modals/show", {
                    title: "",
                    type: "subscribe-newslstter",
                    data: {},
                    wide: false
                })
                .then((resolved) => {
                    /* for (let prop in resolved.related) {
                        this.$set(this.filters, prop, resolved.related[prop]);
                    }
                    merge(this.filters, resolved.related); */
                });
        },
        submit(e) {
            this.loading = true;

            axios
                .post(e.target.action, this.subscriber)
                .then((response) => {
                    this.$toasted.show(
                        "Thanks for your interest! We've successfully added you to our mailing list.",
                        {
                            type: "success",
                        }
                    );
                })
                .catch((error) => {})
                .then(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
